module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume009.d86730ac.webp";